import { render, staticRenderFns } from "./plateMakingQuality.vue?vue&type=template&id=89ce7390&scoped=true&"
import script from "./plateMakingQuality.vue?vue&type=script&lang=js&"
export * from "./plateMakingQuality.vue?vue&type=script&lang=js&"
import style0 from "./plateMakingQuality.vue?vue&type=style&index=0&id=89ce7390&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ce7390",
  null
  
)

export default component.exports